import React from 'react';
import PropTypes from 'prop-types';

import formatCurrency from 'components/utils/formatCurrency';

export default function TotalRow({ cycle, payments }) {
  const total = payments.reduce(
    (sum, item) => sum + parseFloat(item.attributes.deduction),
    0,
  );

  return (
    <div className="d-flex justify-content-end mt-2">
      <div>
        Total
        <span className="ps-1">{formatCurrency(total, cycle.attributes.currency)}</span>
      </div>
    </div>
  );
}

TotalRow.propTypes = {
  cycle: PropTypes.object.isRequired,
  payments: PropTypes.arrayOf(PropTypes.object).isRequired,
};
